// Completion rule (VOD03), mirrored from the server for optimistic display.

/** T = max(min(0.95·D, D − 120), 0.5·D); null when the duration is unknown or zero (never auto-complete). */
export function completionThresholdSec(durationSec: number | null): number | null {
  if (durationSec === null || !(durationSec > 0)) return null;
  return Math.max(Math.min(0.95 * durationSec, durationSec - 120), 0.5 * durationSec);
}

export function isAutoCompleted(positionSec: number, durationSec: number | null): boolean {
  const t = completionThresholdSec(durationSec);
  return t !== null && positionSec >= t;
}
